import { Icon } from '@chakra-ui/react'
import { PiCopyBold } from 'react-icons/pi'

export const CopyIcon = ({ color }: { color?: string }) => (
	<Icon as={PiCopyBold} boxSize='18px' color={color} />
)
